import Common from '../../common/services/Common';
import Rights from '../../common/services/Rights';
import Session, {
  ALL_SUMMARY_PARAMS,
  IS_BUYSIDE,
  IS_DEBUG,
  IS_SELLSIDE,
  IS_VALIDATE,
  JWT_TOKEN,
  USER_TYPE,
} from '../../common/services/Session';
import api from '../../common/utils/api';
import { callDebugRestProxy } from '../../common/services/debugRestProxyServices';

class AdjustmentDetailsService {
  async getAdjustmentDetails(
    loanId,
    lienPosition,
    programId,
    rateDataId,
    eppsUserName,
    requestAction,
    loanChannel,
    rateEffectiveDate,
    wcpPolicyApplied,
  ) {
    let loanUseRateDateAsEffectiveDate = false;
    if (wcpPolicyApplied) {
      loanUseRateDateAsEffectiveDate = true;
    }
    const isBuyside = !Session.get(IS_BUYSIDE) || null;
    const isSellside = !Session.get(IS_SELLSIDE) || null;
    const isValidate = !Session.get(IS_VALIDATE) || null;
    const showLoanOfficer =
      Rights.AssignLoanOfficer && (isBuyside || isSellside || isValidate);
    const wcpEffectiveDate = loanUseRateDateAsEffectiveDate
      ? rateEffectiveDate
      : undefined;
    const baseData: {
      loanId: any;
      lienPosition: any;
      specificRateDataID: any;
      programId: any;
      requestAction: any;
      LoanInformation: {
        LoanChannel: any;
      };
      eppsUserName?: any;
      effectiveDate?: string;
    } = {
      loanId,
      lienPosition,
      specificRateDataID: rateDataId,
      programId,
      requestAction,
      LoanInformation: {
        LoanChannel: loanChannel,
      },
      effectiveDate: wcpEffectiveDate,
    };
    if (showLoanOfficer) {
      baseData.eppsUserName = eppsUserName;
    }
    const bodyData = JSON.stringify(baseData);
    let details = {};
    const user = Session.get(USER_TYPE);
    if (Session.get(IS_DEBUG)) {
      details = await callDebugRestProxy({
        key: 'adjustments',
        pathParameters: { programId },
        payload: baseData,
      });
    } else if (user && user.userType === 'StandAlone') {
      details = await api.getAdjustmentDetails(programId, {
        body: bodyData,
        customToken: { value: Session.get(JWT_TOKEN) },
        tokenType: 'Bearer',
      });
    } else {
      details = await api.getWebhookData(
        {
          headers: { 'X-Elli-PAT': await Common.getPATToken() },
          body: bodyData,
        },
        await Common.getOriginId(),
        'AdjustmentDetails',
      );
    }

    return details;
  }
}

export default new AdjustmentDetailsService();
